import React from "react";

const Footer = () => {
  return (
    <footer className="app-footer">
      Copyright (c) ECtech-Software v1.03.00002025
    </footer>
  );
};

export default Footer;
